import React, { useState } from "react";
import PropertyCard from "./PropertyCard";
import "./ResidentalProperties.css";
import Tulsi1 from "./Images/tulsi1.jpg";
import Satyam from "./Images/Satyam7.jpeg";
import Nilkanth from "./Images/Nilkanth1.jpeg";
import Golden from "./Images/Golden1.jpeg";
import { FaFilter, FaSortAmountDown, FaList, FaSearch } from "react-icons/fa";

// Residential Properties Data
const residentialProperties = [
  {
    id: 101,
    areaLocation: " Patiya Ankleshwar",
    title: "Tulsi Patra 3 BHK",
    location: "Gadkhol Patiya Opp:Aiyappa manidr, Ankleshwar",
    image: Tulsi1,
    type: "For Sale",
    isFeatured: true,
    imageCount: 3,
    listedDate: "2026-05-24",
    viewCount: 4250,
    propertyType: "residential",
    beds: 4,
    baths: 3,
    area: "815 OR 625 sqft",
    amenities: ["24 Hrs Water Facility", "2 AC Point",]
  },
  {
    id: 102,
    areaLocation: " Rajpipla Chokadi Ankleshwar",
    title: "Satyam Residency",
    location: "Rajpipla Chowkadi NH-48,opp.Varsha Hotel",
    image: Satyam,
    type: "For Sale",
    isFeatured: true,
    imageCount: 6,
    listedDate: "2026-05-24",
    viewCount: 2890,
    propertyType: "residential",
    beds: 3,
    baths: 2,
    area: "551 sqft",
    amenities: ["Temple", "Garden","Parking"]
  },
  {
    id: 103,
    areaLocation: " Andara Ankleshwar",
    title: "Nilkanth Varni Bungalow",
    location: "800 mtrs ahead of Gadkhol Patiya, Opp. Aiyappa Mandir, Ankleshwar.",
    image: Nilkanth,
    type: "For Sale",
    isFeatured: true,
    imageCount: 10,
    listedDate: "2026-05-24",
    viewCount: 5100,
    propertyType: "residential",
    beds: 3,
    baths: 3,
    area: "560 sqft",
    // amenities: [""]
  },
  {
    id: 104,
    areaLocation: "Ankleshwar-Bharuch Road",
    title: "Golden Nirvana 2/3 BHK ",
    location: "Near Golden Villa, Ankleshwar-Bharuch Road",
    image: Golden,
    type: "For Sale",
    isFeatured: false,
    imageCount: 7,
    listedDate: "2026-05-24",
    viewCount: 3560,
    propertyType: "residential",
    beds: 5,
    baths: 4,
    area: "850 sqft",
    // amenities: ["Private Garden", "Swimming Pool", "Servant Quarter", "Parking"]
  },
  
];

export default function ResidentialProperties() {
  const [visibleCount, setVisibleCount] = useState(6); // show 6 initially

  const [viewMode, setViewMode] = useState("grid");
  const [filterType, setFilterType] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("featured");

  // ✅ NEW: State for Area Location filter
  const [selectedArea, setSelectedArea] = useState("All");

  // ✅ NEW: Extract unique area locations from residentialProperties data
  const allAreaLocations = ["All", ...new Set(residentialProperties
    .map(property => property.areaLocation?.trim())
    .filter(area => area && area.trim() !== "")
    .map(area => area.trim())
  )];

  // Filter properties - BY DEFAULT ONLY RESIDENTIAL ✅
  const filteredProperties = residentialProperties.filter(property => {
    // ✅ NEW: First apply area location filter (if not 'All')
    if (selectedArea !== "All" && property.areaLocation?.trim() !== selectedArea) {
      return false;
    }

    // ✅ BY DEFAULT: Only residential properties

    if (filterType === "sale" && property.type !== "For Sale") return false;
    if (filterType === "rent" && property.type !== "For Rent") return false;

    if (searchTerm.trim() !== "") {
      const searchLower = searchTerm.toLowerCase();
      const matchesSearch =
        property.title.toLowerCase().includes(searchLower) ||
        property.location.toLowerCase().includes(searchLower) ||
        (property.amenities && property.amenities.some(amenity =>
          amenity.toLowerCase().includes(searchLower)
        )) ||
        (property.beds && searchLower.includes("bed") && property.title.toLowerCase().includes("bhk")) ||
        (property.area && property.area.toLowerCase().includes(searchLower));

      if (!matchesSearch) return false;
    }

    return true;
  });

  const sortedProperties = [...filteredProperties].sort((a, b) => {
    switch (sortBy) {
      case "newest":
        return new Date(b.listedDate) - new Date(a.listedDate);
      case "featured":
      default:
        if (a.isFeatured && !b.isFeatured) return -1;
        if (!a.isFeatured && b.isFeatured) return 1;
        return new Date(b.listedDate) - new Date(a.listedDate);
    }
  });

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleResetFilters = () => {
    setFilterType('all');
    setSearchTerm('');
    setSelectedArea('All'); // ✅ NEW: Reset area filter too
  };

  return (
    <section className="residential-section">

      <div className="residential-header">
        <div className="residential-header-left">
          <h2 className="residential-title">Residential Properties</h2>
          <p className="residential-subtitle">Find your dream home - Villas, Apartments, Flats & Bungalows</p>
        </div>

        <div className="residential-header-right">
          <span className="residential-count">
            {sortedProperties.length} Residential Properties
            {selectedArea !== "All" && ` in ${selectedArea}`} {/* ✅ NEW: Show area if filtered */}
          </span>
        </div>
      </div>

      {/* ✅ NEW: Area Location Filter - Add this ABOVE existing filters */}
      <div className="area-location-filter">
        <h3 className="area-filter-title">Filter by Residential Area Location</h3>
        <div className="area-filter-buttons">
          {allAreaLocations.map(area => (
            <button
              key={area}
              className={`area-filter-btn ${selectedArea === area ? 'area-active' : ''}`}
              onClick={() => setSelectedArea(area)}
              type="button"
            >
              {area === "All" ? "All Residential Areas" : area}
            </button>
          ))}
        </div>
      </div>

      {/* 🟡 EXISTING: Filters and Controls */}
      <div className="residential-controls">
        <div className="residential-filter-buttons">
          <button
            className={`residential-filter-btn ${filterType === 'all' ? 'residential-active' : ''}`}
            onClick={() => setFilterType('all')}
          >
            All Residential
          </button>
          <button
            className={`residential-filter-btn ${filterType === 'sale' ? 'residential-active' : ''}`}
            onClick={() => setFilterType('sale')}
          >
            <FaFilter /> For Sale
          </button>
          <button
            className={`residential-filter-btn ${filterType === 'rent' ? 'residential-active' : ''}`}
            onClick={() => setFilterType('rent')}
          >
            <FaFilter /> For Rent
          </button>

          <div className="residential-search-container">
            <FaSearch className="residential-search-icon" />
            <input
              type="text"
              placeholder="Search residential properties..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="residential-search-input"
              aria-label="Search residential properties"
            />
            {searchTerm && (
              <button
                className="residential-clear-search-btn"
                onClick={() => setSearchTerm("")}
                aria-label="Clear search"
              >
                ✕
              </button>
            )}
          </div>
        </div>

        <div className="residential-view-controls">
          <div className="residential-sort-dropdown">
            <FaSortAmountDown className="residential-sort-icon" />
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="residential-sort-select"
            >
              <option value="featured">Featured First</option>
              <option value="newest">Newest First</option>
            </select>
          </div>

          <div className="residential-view-toggle">
            <button
              className={`residential-view-btn ${viewMode === 'grid' ? 'residential-active' : ''}`}
              onClick={() => setViewMode('grid')}
              aria-label="Grid view"
            >
              {/* Grid icon */}
            </button>
            <button
              className={`residential-view-btn ${viewMode === 'list' ? 'residential-active' : ''}`}
              onClick={() => setViewMode('list')}
              aria-label="List view"
            >
              <FaList />
            </button>
          </div>
        </div>
      </div>

      {/* Properties Grid/List */}
      <div className={`industrial-container ${viewMode}`}>
        {sortedProperties.slice(0, visibleCount).map((item) => (
          <PropertyCard key={item.id} data={item} />
        ))}
      </div>


      {visibleCount < sortedProperties.length && (
        <div className="industrial-view-more-section">
          <button
            className="industrial-view-more-btn"
            onClick={() => setVisibleCount(prev => prev + 6)}
          >
            View More Industrial Properties
          </button>
        </div>
      )}


      {sortedProperties.length === 0 && (
        <div className="residential-no-results">
          <h3>No Residential Properties Found</h3>
          <p>Try changing your filters or check back later for new listings.</p>
          <button
            className="residential-reset-filters-btn"
            onClick={handleResetFilters}
          >
            Reset All Filters
          </button>
        </div>
      )}
    </section>
  );
}